import { Component, OnInit, Input } from "@angular/core"
import { EduComponent } from "../../utils/eduComponent"
import { ResourceService } from "../../services/resource.service"
import { Attribute } from "../../models/attribute.model"
import { Resource } from "../../models/resource/resource"

@Component({
    selector: "app-resource-attributes",
    templateUrl: "./resource-attributes.component.html",
    styleUrls: ["./resource-attributes.component.less"],
})
export class ResourceAttributesComponent extends EduComponent implements OnInit {
    attributions: Attribute[] = []

    constructor(private resourceService: ResourceService) {
        super()
    }

    ngOnInit() {
        this.addSub(
            this.resourceService.resourceResponse.subscribe((resource: Resource) => {
                // let attributes = newCommonProperties.requiredAttributions.map(attribute => {
                //     return new Attribute(attribute);
                // })
                //todo: except brand
                this.setAttributions(resource.attributions)
            })
        )
    }

    setAttributions(newAttributions: Attribute[]) {
        let preparedAttributions = []
        newAttributions.map((attribution) => {
            if (attribution.role === "brand") {
                // These are shown elsewhere
                return
            }
            // Because we don't have ids also check logo url. We have different attributions with the same name
            let addedAttribution = preparedAttributions.find(
                (e) => e.name === attribution.name && e.logoColor === attribution.logoColor
            )
            if (addedAttribution) {
                addedAttribution.roles.push(attribution.role)
                return
            }
            attribution.roles.push(attribution.role)
            preparedAttributions.push(attribution)
        })
        this.attributions = preparedAttributions
    }
}
